import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import FAQQuestion from '../../src/models/FAQQuestion';

document.querySelectorAll('[data-component="faqWidget"]').forEach((el: Element) => {
  const element: HTMLElement = el as HTMLElement
  if (element != null) {
    const id: string = element.getAttribute("data-id") ?? "";
    const title: string = element.getAttribute("data-title") ?? "";
    const content: string = element.getAttribute("data-content") ?? "";

    const question = new FAQQuestion();
    question.id = id;
    question.title = title;
    question.content = content;

    ReactDOM.render(
      <React.StrictMode>
        <App question={question} />
      </React.StrictMode>,
      element
    );
  }
});